import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    form: [],
    user: {},
    isPremium: false,
    isPremiumForm: false
  },
  mutations: {

    //////* USER STATES *//////

    loginUser(state, arg) {
      Vue.set(state, 'user', arg);
    },
    logoutUser(state){
      Vue.set(state, 'user', {});
    },
    setPremiumState(state, premium) {
      Vue.set(state, 'isPremium', premium);
    },
    setPremiumFormState(state, premium) {
      Vue.set(state, 'isPremiumForm', premium);
    },

    //////* FORM STATES *//////

    addToForm(state, form) {
      state.form.push(form);
    },
    setForm(state, form) {
      // Override the current form
      state.form = form;
    },
    removeFromForm(state, qid) {
      // Clone then change state. 
      // This way, the object change is broadcasted.
      var clone = Vue._.clone(state.form, true);
      Vue._.remove(clone, {qid : qid});
      this.state.form = clone;
    },
    removeOptionFromForm(state, arg) {
      Vue._.remove(arg.items, {optionId : arg.optionObj.optionId});
    },
    setTextForQuestionObj(state, arg) {
      const questionObj = arg.questionObj;
      const text = arg.text;
      questionObj.text = text;
    },
    setValueForOptionObj(state, arg) {
      const optionObj = arg.optionObj;
      const value = arg.value;
      optionObj.value = value;
    },
    setAnswerForQuestionObj(state, arg) {
      const questionObj = arg.questionObj;
      const answer = arg.answer;
      questionObj.answer = answer;
    }
  },
  actions: {
    deleteForm(context, qid) {
      context.commit('removeFromForm', qid);
    },
    setLogin(context, arg) {
      context.commit('loginUser', arg);
    }
  }
});
